const api="https://apiexample.asociadosbega.com/public/contactos";
export default api;